import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import BaseFeature from './BaseFeature';
import { DIAGNOSTICS } from '../../../../../../utils/constantFeatures';

class Diagnostics extends BaseFeature {

    constructor(props) {
        super(props);
        this.state = {
            spdEnabled: this.props.properties[DIAGNOSTICS.enableSpd].value === "1" ? true : false,
            spdVisualEnabled: this.props.properties[DIAGNOSTICS.enableVisual].value === "1" ? true : false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };

        this.props.handleChange(propertyName, v);
    }

    render() {

        return (
            <><Row>
                <Col sm={3}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            {this.props.feature['displayName']}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <PropertySwitch
                                property={this.props.properties[DIAGNOSTICS.enableSpd]}
                                title={this.props.properties[DIAGNOSTICS.enableSpd].info.displayName}
                                handleChange={this.handleChange} />
                            <PropertySwitch
                                disabled={this.props.properties[DIAGNOSTICS.enableSpd].value !== "1"}
                                property={this.props.properties[DIAGNOSTICS.enableVisual]}
                                title={this.props.properties[DIAGNOSTICS.enableVisual].info.displayName}
                                handleChange={this.handleChange} />

                        </Card.Body>
                    </Card>
                </Col>
            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(Diagnostics);
